import {
  isCleanroom,
  isClothing,
  isNonClothing,
  NavigationLinks,
  ServiceSegmentCategory,
} from '@mewa/types';

import { Industry } from './components/industry-page-types';

export const getIndustryTabs = (
  industry: Industry,
  langPrefix: string,
  navigation: NavigationLinks['navigation'],
  featureDev = false,
) => {
  const tabLinks = industry.serviceSegments.filter(isClothing).map((s) => ({
    label: s.name,
    to: `${langPrefix}/${industry.slug}-${s.slug}`,
  }));

  const hasNonClothingSegments =
    industry.serviceSegments.filter((s) => isNonClothing(s)).length > 0;
  const hasCleanroomSegments =
    industry.serviceSegments.filter((s) => isCleanroom(s)).length > 0;

  if (hasNonClothingSegments) {
    tabLinks.push({
      label: navigation.nonClothing.name,
      to: `${langPrefix}/${industry.slug}-${navigation.nonClothing.slug}`,
    });
  }

  if (featureDev && hasCleanroomSegments) {
    tabLinks.push({
      label: navigation.cleanroom.name,
      to: `${langPrefix}/${industry.slug}-${navigation.cleanroom.slug}`,
    });
  }

  return tabLinks;
};

export const getServiceSegmentSlugForIndustry = (
  industry: {
    serviceSegments: {
      slug: string;
      category: ServiceSegmentCategory;
    }[];
  },
  navigation: NavigationLinks['navigation'],
) => {
  return isClothing(industry.serviceSegments[0])
    ? industry.serviceSegments[0].slug
    : isNonClothing(industry.serviceSegments[0])
      ? navigation.nonClothing.slug
      : navigation.cleanroom.slug;
};

export const filterCleanroomIndustries =
  (featureDev = false) =>
  (i: { serviceSegments: { category: ServiceSegmentCategory }[] }) =>
    featureDev ||
    i.serviceSegments.some((s) => isClothing(s) || isNonClothing(s));
